import { lazy, Suspense, type FC } from "react"
import { Routes, Route } from "react-router-dom"
import { RouteEnum } from "../mainRoute"
import {
    OAuthPage,
    PersonalAccountPage,
    PrivacyPage,
    PrivacyPersonalDataPage,
    PrivacyUserAgreementPage,
    SignInPage
} from "../../../presentation/pages"
import GradeSystemPage from "../../../presentation/pages/GradeSystem"
import { ProtectedRoute } from "presentation/components"

const CertificatePreviewPage = lazy(async () => await import("../../../presentation/pages/CertificatePreview"))

const Router: FC = () => {
    return (
        <Routes>
            {process.env.NODE_ENV === "development" && (
                <Route
                    path="/certificate-preview"
                    element={<Suspense fallback={<p>Загружаем предпросмотр…</p>}><CertificatePreviewPage /></Suspense>}
                />
            )}
            <Route
                path={`/${RouteEnum.LOGIN}`}
                element={<SignInPage />}
            />
            <Route
                path={`/${RouteEnum.OAUTH}`}
                element={<OAuthPage />}
            />
            <Route
                path={`/${RouteEnum.PRIVACY}`}
            >
                <Route
                    index
                    element={<PrivacyPage />}
                />
                <Route
                    path={RouteEnum.PERSONAL_DATA}
                    element={<PrivacyPersonalDataPage />}
                />
                <Route
                    path={RouteEnum.USER_AGREEMENT}
                    element={<PrivacyUserAgreementPage />}
                />
            </Route>
            {/* //* protected routes */}
            <Route
                element={<ProtectedRoute/>}
            >
                <Route
                    path={`/${RouteEnum.MAIN}`}
                    element={<GradeSystemPage />}
                />
                <Route
                    path={`/${RouteEnum.PROFILE}`}
                    element={<PersonalAccountPage />}
                />
            </Route>
        </Routes>
    )
}

export default Router
